/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["div:hover{background-color:#f7f7f7;cursor:pointer}label{margin-bottom:0!important}div{margin:2px}"];
export { styles as styles };
